import React, { useState } from 'react'
import { Layout, Steps, Button } from 'antd'
import Exitwithoutfinishing from '../../pages/Events/Views/Exitwithoutfinishing'
import './styles/sidebar.scss'
import { creationEventStore } from 'state/event/eventCreationStore'
import { List } from '@phosphor-icons/react'
import { EventResp } from 'types/event/events'

const { Sider } = Layout
const EventSidebar: React.FC = () => {
  const [isSidebarOpen, setIsSidebarOpen] = useState(false)
  const { Step } = Steps
  const [isModalVisibleEvent, setModalVisibleEvent] = useState(false)
  const {
    eventData,
    stepCounter,
    setStepCounter,
  }: {
    eventData: EventResp | null
    stepCounter: number
    setStepCounter: (state: number) => void
  } = creationEventStore(store => ({
    eventData: store.eventData,
    stepCounter: store.stepCounter,
    setStepCounter: store.setStepCounter,
  }))

  const steps = [
    {
      title: 'Step 1',
      description: (
        <div className="flex justify-between align-center">
          <b className="text-18 w-600">General Details</b>
          <button
            className={`progress-bar-btn ${
              eventData && eventData.statuses.details
                ? 'active'
                : 'non-active disabled'
            }`}
            disabled={!eventData?.statuses.details}
            onClick={() => setStepCounter(0)}
          >
            {eventData && eventData.statuses.details ? 'Review' : 'Start'}
          </button>
        </div>
      ),
    },
    {
      title: 'Step 2',
      // description: <b className="text-18 w-600">Schedule and activities</b>,
      description: (
        <div className="flex justify-between align-center">
          <b className="text-18 w-600">Schedule and activities</b>
          <button
            className={`progress-bar-btn ${
              eventData && eventData.statuses.schedule ? 'active' : 'non-active'
            } ${eventData && eventData.statuses.details ? '' : 'disabled'}`}
            disabled={!eventData?.statuses.details}
            onClick={() => setStepCounter(1)}
          >
            {eventData && eventData.statuses.schedule ? 'Review' : 'Start'}
          </button>
        </div>
      ),
    },
    {
      title: 'Step 3',
      description: (
        <div className="flex justify-between align-center">
          <b className="text-18 w-600">Supplies & Cost</b>
          <button
            className={`progress-bar-btn ${
              eventData && eventData.statuses.suppliesAndCost
                ? 'active'
                : 'non-active'
            } ${eventData && eventData.statuses.details ? '' : 'disabled'}`}
            disabled={!eventData?.statuses.details}
            onClick={() => setStepCounter(2)}
          >
            {eventData && eventData.statuses.suppliesAndCost
              ? 'Review'
              : 'Start'}
          </button>
        </div>
      ),
      // description: <b className="text-18 w-600">Supplies & Cost</b>,
    },
    {
      title: 'Step 4',
      description: (
        <div className="flex justify-between align-center">
          <b className="text-18 w-600">Manage tickets</b>
          <button
            className={`progress-bar-btn ${
              eventData && eventData.statuses.tickets ? 'active' : 'non-active'
            } ${eventData && eventData.statuses.details ? '' : 'disabled'}`}
            disabled={!eventData?.statuses.details}
            onClick={() => setStepCounter(3)}
          >
            {eventData && eventData.statuses.tickets ? 'Review' : 'Start'}
          </button>
        </div>
      ),
      // description: <b className="text-18 w-600">Manage tickets</b>,
    },
    {
      title: 'Step 5',
      description: (
        <div className="flex justify-between align-center">
          <b className="text-18 w-600">Communication</b>
          <button
            className={`progress-bar-btn ${
              eventData && eventData.statuses.communication
                ? 'active'
                : 'non-active'
            } ${eventData && eventData.statuses.details ? '' : 'disabled'}`}
            disabled={!eventData?.statuses.details}
            onClick={() => setStepCounter(4)}
          >
            {eventData && eventData.statuses.communication ? 'Review' : 'Start'}
          </button>
        </div>
      ),
      // description: <b className="text-18 w-600">Additional event settings</b>,
    },
    {
      title: 'Step 6',
      description: (
        <div className="flex justify-between align-center">
          <b className="text-18 w-600">Settings</b>
          <button
            className={`progress-bar-btn ${
              eventData && eventData.statuses.settings ? 'active' : 'non-active'
            } ${eventData && eventData.statuses.details ? '' : 'disabled'}`}
            disabled={!eventData?.statuses.details}
            onClick={() => setStepCounter(5)}
          >
            {eventData && eventData.statuses.settings ? 'Review' : 'Start'}
          </button>
        </div>
      ),
    },
  ]

  return (
    <div>
      <div
        className="event-list-icon"
        onClick={() => setIsSidebarOpen(!isSidebarOpen)}
      >
        <List size={30} color="#000" />
      </div>

      <Sider
        className={`side-bar create-event-side-bar  ${
          isSidebarOpen ? 'sidebar-open' : ''
        }`}
        width={'auto'}
        style={{ maxWidth: 'auto' }}
      >
        <div className="d-flex flex-column justify-between stepper-section-header pb-10">
          <div>
            <h2 className="mb-16 create-event-sidebar-heading">Create event</h2>
            <span className="mb-20 complete-all-steps">
              Complete all steps to create the event, you can also save it as a
              draft at any step.
            </span>
            <Steps direction="vertical" current={stepCounter}>
              {steps.map(item => (
                <Step
                  key={item.title}
                  className="stepper event-stepper event-step-bar"
                  title={item.title}
                  description={item.description}
                />
              ))}
            </Steps>
          </div>
          <div className="mt-30 save-progress-and-exit">
            <Button
              className="primary-transparent mb-30"
              style={{ width: '100%', height: '50px' }}
              onClick={() => {
                setModalVisibleEvent(true)
              }}
            >
              Save progress & exit
            </Button>
          </div>
        </div>
        {isModalVisibleEvent ? (
          <Exitwithoutfinishing
            isModalVisibleEvent={isModalVisibleEvent}
            setModalVisibleEvent={setModalVisibleEvent}
          />
        ) : (
          <></>
        )}
      </Sider>
    </div>
  )
}

export default EventSidebar
